import type { ReactNode } from 'react';

export function effectiveValue<T>(
  branchVal: T | null | undefined,
  supplierDefault: T | null | undefined,
): { value: T | null; inherited: boolean } {
  if (branchVal !== null && branchVal !== undefined && branchVal !== ('' as unknown as T)) {
    return { value: branchVal, inherited: false };
  }
  return { value: supplierDefault ?? null, inherited: true };
}

export function DefaultsCascadeEditor({
  supplierDefaults,
  branchEffective,
}: {
  // The editable supplier-level defaults (form-controlled by the parent route).
  supplierDefaults: ReactNode;
  // Read-only "effective per branch" rows the parent computes via effectiveValue.
  branchEffective: { label: string; value: ReactNode; inherited: boolean }[];
}) {
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div className="card" style={{ padding: 12 }}>
        <div className="meta" style={{ marginBottom: 6 }}>
          ค่าตั้งต้นระดับผู้ขาย (ใช้กับทุกสาขาเว้นแต่กำหนดเอง)
        </div>
        {supplierDefaults}
      </div>
      <div>
        <div className="meta" style={{ marginBottom: 4 }}>
          ค่าที่มีผลจริงต่อสาขา
        </div>
        <table className="tbl" style={{ width: '100%', fontSize: 13 }}>
          <tbody>
            {branchEffective.map((r) => (
              <tr key={r.label}>
                <td style={{ width: 220 }}>{r.label}</td>
                <td>
                  {r.value ?? <span className="muted">—</span>}
                  {r.inherited && (
                    <span className="badge neutral" style={{ marginLeft: 6 }}>
                      สืบทอด
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
